import { Box, Skeleton, SkeletonProps } from '@mui/material';
import { DataCardProps } from '../data-card.component';

export type SlotProps = {
  slot: DataCardProps['slots'][keyof DataCardProps['slots']];
  shouldRenderDefault?: boolean;
  loading?: boolean;
  SkeletonProps?: SkeletonProps;
  children?: React.ReactNode;
};

export const Slot = ({
  slot,
  shouldRenderDefault,
  loading,
  SkeletonProps = {},
  children,
}: SlotProps) => {
  if (loading)
    return (
      <Box py="2px" sx={{ width: '100%' }}>
        <Skeleton variant="rectangular" {...SkeletonProps} />
      </Box>
    );
  if (slot) return slot;
  if (shouldRenderDefault) return children;

  return null;
};
export default Slot;
